import request from '../../utils/request';
import { Result } from '../../models/general';
import {
  EmployeeGosiRecordView,
  EmployeeGosiRecordInput,
  GosiRateScheduleView,
  GosiRateScheduleInput,
  KsaGosiPanelData,
} from '../../models/payroll';

export async function getGosiEmployeeRecord(userId: string): Promise<Result<EmployeeGosiRecordView>> {
  const response = await request.get<Result<EmployeeGosiRecordView>>(
    `Payroll/Gosi/employee/${encodeURIComponent(userId)}`
  );
  return response.data;
}

export async function upsertGosiEmployeeRecord(
  userId: string,
  input: EmployeeGosiRecordInput,
): Promise<Result<EmployeeGosiRecordView>> {
  const response = await request.put<Result<EmployeeGosiRecordView>>(
    `Payroll/Gosi/employee/${encodeURIComponent(userId)}`,
    input,
  );
  return response.data;
}

export async function listGosiRates(): Promise<Result<GosiRateScheduleView[]>> {
  const response = await request.get<Result<GosiRateScheduleView[]>>('Payroll/Gosi/rates');
  return response.data;
}

export async function createGosiRate(input: GosiRateScheduleInput): Promise<Result<GosiRateScheduleView>> {
  const response = await request.post<Result<GosiRateScheduleView>>('Payroll/Gosi/rates', input);
  return response.data;
}

export async function updateGosiRate(id: number, input: GosiRateScheduleInput): Promise<Result<GosiRateScheduleView>> {
  const response = await request.put<Result<GosiRateScheduleView>>(`Payroll/Gosi/rates/${id}`, input);
  return response.data;
}

export async function archiveGosiRate(id: number): Promise<Result<boolean>> {
  const response = await request.delete<Result<boolean>>(`Payroll/Gosi/rates/${id}`);
  return response.data;
}

export async function getGosiPanelData(year: number, month: number): Promise<Result<KsaGosiPanelData>> {
  const response = await request.get<Result<KsaGosiPanelData>>(`Payroll/Gosi/panel/${year}/${month}`);
  return response.data;
}
